var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.571 1.487H3.286A2.286 2.286 0 001 3.772v25.143a2.286 2.286 0 002.286 2.286H21.57a2.286 2.286 0 002.286-2.286V3.772a2.286 2.286 0 00-2.286-2.285zM10.429 25.487h3.428",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.761 12.219l-4.332 6.36v1.765h12.458v-2.237H8.385v-.079l3.996-5.81h-2.62z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97 7.344V9.58h9.502v.079l-3.996 5.81h2.62l4.333-6.361V7.344H5.97z",
    fill: "currentColor"
  })));
}
export default SvgWhatsUp;